
import { defineComponent } from "vue";

export default defineComponent({
  name: "QuizAnswer",
  props: ["id", "title", "modelValue"],
  emits: ["update:modelValue"],
});
